module.exports = __webpack_public_path__ + "static/media/work7.8b513afe.jpg";